import { Button, DatePicker, Select, Spin, Table, Tag } from "antd";
import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import {
  ActiveDeactiveServicesReport,
  LoginHistoryReport,
} from "../../../ApiServices/Apifun";
import { AiOutlineSearch } from "react-icons/ai";
import { setselectedTab } from "../../../Store/B2bslice";
import { useDispatch, useSelector } from "react-redux";
import CommonInput from "../../../Common/CommonInput";
import CommonPagination from "../../../Common/Pagination";

const ActiveDeactiveServices = () => {
  const dispatch = useDispatch();
  const [dataSource, setDataSource] = useState([]);
  const [current, setCurrent] = useState(1);
  const [totalAmt, setTotalAmt] = useState();
  const [searchKeyword, setSearchKeyWord] = useState("");
  const [searchcolumn, setSearchColumn] = useState(null);
  const [memberTypeFilter, setMemberTypeFilter] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [totalPages, setTotalPages] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [searchOptions, setSearchOptions] = useState([]);
  const [memberOptions, setMemberOptions] = useState([]);
  const profiledetail = useSelector((state) => state.B2B.profileDetail);
  const memberServices = useSelector((state) => state.B2B.memberServices);

  const [loading, setLoading] = useState(false);
  const ReportColumn = [
    {
      title: "Services",
      dataIndex: "service_name",
      key: "service_name",
      render: (text) => {
        return (
          <>
            <p className=" font-medium  ">{text}</p>
          </>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "mapping_id",
      key: "mapping_id",
      render: (text) => (
        <Tag
          className={`font-medium w-[120px] text-center rounded-md p-1 ${
            text
              ? "bg-green-500 text-white border-green-500"
              : "bg-red-500 text-white border-red-400"
          }`}
        >
          {text ? "Active" : "Inactive"}
        </Tag>
      ),
    },
  ];

  const getReport = (
    search_keyword = searchKeyword,
    search_column = searchcolumn ?? "",
    filter_member_id = memberTypeFilter ?? "",
    from_date = fromDate,
    to_date = toDate,
  ) => {
    setLoading(true);
    const payload = {
      per_page: pageSize,
      page_no: current,
      search_keyword: search_keyword,
      search_column: search_column,
      filter_member_id: filter_member_id,
      from_date: from_date,
      to_date: to_date,
    };
    const formdata = new FormData();
    Object.keys(payload).map((key) => formdata.append(key, payload[key]));
    ActiveDeactiveServicesReport(formdata)
      .then((res) => {
        setTotalAmt(res.total_amount);
        // const activeServices = res.services.filter((service) =>
        //   memberServices.includes(service.mapping_id),
        // );

        // const inactiveServices = res.services.filter(
        //   (service) => !memberServices.includes(service.mapping_id),
        // );

        // console.log(activeServices, "active");
        // console.log(inactiveServices, "inactive");
        // const updatedServices = res.services.map((service) => ({
        //   ...service,
        //   isActive: memberServices.includes(service.mapping_id),
        // }));

        setDataSource(res.services);
        setTotalPages(res.total);
        setSearchOptions(
          res?.filter_column_name?.map((i, index) => {
            return {
              label: i,
              value: res.filter_column_key[index],
            };
          }),
        );
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };
  useEffect(() => {
    getReport();
  }, [current, pageSize, memberTypeFilter]);
  console.log(dataSource, "profiledetail");
  useEffect(() => {
    dispatch(setselectedTab("11.18"));
    // profiledetail.member_type !== "Retailer" && getMemberFilter();
  }, []);

  return (
    <>
      <div className="">
        <div className="prepaid  animate-fade-in w-full  bg-white shadow-normal  rounded-xl p-4">
          <div className="flex justify-between items-center">
            <p className="font-bold text-[15px] mb-2">
              Active / Deactive Services
            </p>
            <p
              onClick={() => {
                getReport("", "", "", "");
                setSearchKeyWord("");
                setSearchColumn(null);
                setMemberTypeFilter(null);
                setFromDate("");
                setToDate("");
              }}
              className="font-medium text-xs cursor-pointer bg-bsred hover:bg-red-600 text-white px-2 py-1 rounded-md text-[15px] mb-2"
            >
              Clear Filter
            </p>
          </div>
          <div
            className={`selectionFields grid grid-cols-1 gap-4 place-items-center 
  ${
    profiledetail.member_type !== "Retailer"
      ? "md:grid-cols-4"
      : "md:grid-cols-3"
  }
`}
          >
            <div className="w-full">
              <p className={`required text-textGray mt-2`}>
                Select Search Type
              </p>
              <Select
                placeholder="Select search type"
                value={searchcolumn}
                onChange={(val) => setSearchColumn(val)}
                className="w-full mt-2"
                options={searchOptions}
              />
            </div>
            <div className="w-full">
              <p className={`required text-textGray `}>Keyword</p>
              {searchcolumn === "aeps_aadhar_pay.created_at" ? (
                <DatePicker
                  // value={dayjs("2023-09-07","YYYY-MM-DD")}
                  popupClassName="bottom-calendar"
                  allowClear
                  // value={searchKeyword}
                  className="w-full datepicker mt-4"
                  onChange={(val) =>
                    setSearchKeyWord(dayjs(val).format("YYYY-MM-DD"))
                  }
                  placement="bottomLeft"
                  placeholder="Search"
                />
              ) : (
                <CommonInput
                  placeholder="Seacrh"
                  value={searchKeyword}
                  onChange={(e) => setSearchKeyWord(e.target.value)}
                  className="outline-none text-xs border mt-4 w-full  border-gray-200 focus:border-primary   px-2 "
                />
              )}
            </div>
            {profiledetail.member_type !== "Retailer" && (
              <div className="w-full">
                <p className={`required text-textGray mt-2`}>
                  Select Member Type
                </p>
                <Select
                  placeholder="Select member type"
                  value={memberTypeFilter}
                  onChange={(val) => setMemberTypeFilter(val)}
                  className="w-full mt-2"
                  options={memberOptions}
                />
              </div>
            )}
            <div className="w-full">
              <p className={`required text-textGray mt-2`}>
                From Date - To Date
              </p>
              <DatePicker.RangePicker
                allowClear
                onChange={(val) => {
                  setFromDate(val ? dayjs(val[0]).format("YYYY-MM-DD") : "");
                  setToDate(val ? dayjs(val[1]).format("YYYY-MM-DD") : "");
                }}
                className="w-full mt-2"
              />
            </div>{" "}
          </div>
          <div className="w-full flex justify-between items-center mt-3">
            {totalAmt === 0 ? (
              ""
            ) : (
              <p
                style={{ color: "white" }}
                className=" font-semibold flex justify-between gap-2 items-center p-2 rounded-md  hover:bg-primaryhover bg-primary border-none"
              >
                <p>Total Amount : ₹ {totalAmt}</p>
              </p>
            )}
            <Button
              // disabled=
              onClick={() => getReport()}
              style={{ color: "white" }}
              className=" font-semibold flex justify-between gap-2 items-center hover:bg-primaryhover bg-primary border-none"
            >
              <AiOutlineSearch />
              <p>Search</p>
            </Button>
          </div>
        </div>
      </div>
      <div>
        <div className="mt-4">
          <Spin spinning={loading}>
            <Table
              className="history-table animate-fade-in max-h-[500px]  overflow-x-auto text-white rounded-lg"
              columns={ReportColumn}
              pagination={false}
              dataSource={dataSource}
            />
            <div className="mt-2 mb-8 flex justify-end items-center">
              <CommonPagination
                totalPages={totalPages}
                current={current}
                pageSize={pageSize}
                setCurrent={setCurrent}
                setPageSize={setPageSize}
              />
            </div>
          </Spin>
        </div>
      </div>
      {/* {openReceiptDrawer && (
        <ReportDrawer
          title={"AadharPay Receipt"}
          open={openReceiptDrawer}
          setOpen={setOpenReceiptDrawer}
            data={result}
        />
      )} */}
    </>
  );
};

export default ActiveDeactiveServices;
